import { combineReducers } from "redux";
import * as actionTypes from "../actions/index.js";

const usersReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_USERS:
      return action.payload;
    default:
      return state;
  }
};

// Define el reducer para el state de los challenges
const challengesReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_CHALLENGES:
      return action.payload;
    case actionTypes.CREATE_CHALLENGE:
      return [...state, action.payload];
    case actionTypes.ADD_CHALLENGE:
      return [...state, action.payload];
    case actionTypes.REMOVE_CHALLENGE:
      return state.filter((el) => el._id !== action.payload);
    default:
      return state;
  }
};

const specificChallenge = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_SPECIFIC_CHALLENGE:
      return action.payload;
    case actionTypes.EMPTY_SPECIFIC_CHALLENGE:
      return {};
    default:
      return state;
  }
};

const ownChallengesReducer = (state = null, action) => {
  switch (action.type) {
    case actionTypes.GET_OWN_CHALLENGES:
      return action.payload;
    case actionTypes.ADD_CHALLENGE:
      return [...state, action.payload];
    case actionTypes.REMOVE_CHALLENGE:
      return state.filter((el) => el._id !== action.payload);
    default:
      return state;
  }
};

const specificUserReducer = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_SPECIFIC_USER:
    case actionTypes.UPDATE_USER:
      return action.payload;
    case actionTypes.EDIT_PROFILE_LASTNAME:
      return { ...state, lastName: action.payload };
    case actionTypes.EDIT_PROFILE_NAME:
      return { ...state, name: action.payload };
    case actionTypes.CHANGE_COMPANY:
      // console.log(action.payload);
      return action.payload;
    default:
      return state;
  }
};

const rankingReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_RANKING:
      return action.payload;
    default:
      return state;
  }
};

const createStage = (state = null, action) => {
  switch (action.type) {
    case actionTypes.CREATE_STAGE:
      return action.payload;
    case actionTypes.DELETE_STAGE:
      return action.payload;
    default:
      return state;
  }
};

const getStages = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_STAGES:
      return action.payload;
    default:
      return state;
  }
};

const getSpecificStage = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_SPECIFIC_STAGE:
      return action.payload;
    default:
      return state;
  }
};

const getCompany = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANY:
      return action.payload;
    case actionTypes.UPDATE_COMPANY:
      return action.payload;
    default:
      return state;
  }
};
const companyMsgReducer = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CREATE_COMPANY:
      return "¡Organización creada con exito!";
    case actionTypes.CLEAR_COMPANY_MSG:
      return "";
    default:
      return state;
  }
};

const challengeMsgReducer = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CREATE_CHALLENGE:
      return "¡Desafío creado con éxito!";
    case actionTypes.ADD_CHALLENGE:
      return "¡Desafío añadido con éxito!";
    case actionTypes.REMOVE_CHALLENGE:
      return "¡Desafío eliminado con éxito!";
    case actionTypes.CLEAR_CHALLENGE_MSG:
      return "";
    default:
      return state;
  }
};

// const getChallengeAdminDetails = (state = {}, action) => {
//   switch (action.type) {
//     case actionTypes.GET_CHALLENGE_ADMIN_DETAILS:
//       return action.payload;
//     case actionTypes.SORT_BY_NAME:
//       const users = state;
//       let sortByName =
//         action.payload === "desc"
//           ? users.users.sort((a, b) => a.name.localeCompare(b.name))
//           : action.payload === "asc"
//           ? users.users.sort((a, b) => b.name.localeCompare(a.name))
//           : null;

//       return { ...state, users: sortByName };
//     case actionTypes.SORT_BY_POINTS:
//       console.log(state);
//       const users2 = state;

//       let sortByPoints =
//         action.payload === "desc"
//           ? users2.users.sort(function (a, b) {
//               if (!b.challenge) return -1;
//               return b.challenge?.earnedPoints - a.challenge?.earnedPoints;
//             })
//           : action.payload === "asc"
//           ? users2.users.sort(function (a, b) {
//               if (!a.challenge) return -1;
//               return a.challenge?.earnedPoints - b.challenge?.earnedPoints;
//             })
//           : null;

//       return { ...state, users: sortByPoints };
//     case actionTypes.SORT_BY_POSITION:
//       console.log(state);
//       const users5 = state;

//       let sortByPosition =
//         action.payload === "desc"
//           ? users5.users.sort(function (a, b) {
//               return b?.index - a?.index;
//             })
//           : action.payload === "asc"
//           ? users5.users.sort(function (a, b) {
//               return a?.index - b?.index;
//             })
//           : null;

//       return { ...state, users: sortByPosition };
//     case actionTypes.SORT_BY_PERCENT:
//       const users3 = state;
//       let sortByPercent =
//         action.payload === "desc"
//           ? users3.users.sort(function (a, b) {
//               if (!b.challenge) return -1;
//               return (
//                 b.challenge?.contentsCompleted - a.challenge?.contentsCompleted
//               );
//             })
//           : action.payload === "asc"
//           ? users3.users.sort(function (a, b) {
//               if (!a.challenge) return -1;
//               return (
//                 a.challenge?.contentsCompleted - b.challenge?.contentsCompleted
//               );
//             })
//           : null;

//       return { ...state, users: sortByPercent };
//     case actionTypes.LOOK_BY_NAME:
//       const users4 = action.payload[1];
//       let filtered = users4.users.filter((e) =>
//         e.name.toLowerCase().includes(action.payload[0])
//       );
//       if (action.payload[0] === "") return action.payload[1];
//       console.log(state.users);
//       console.log(filtered);
//       return { ...state, users: filtered };
//     default:
//       return state;
//   }
// };

//! Esto es lo de arriba, pero modulado, sino va, borrar y descomentar lo otro.
//! Solo saque la logica para afuera

const sortByName = (users, order) => {
  return [...users].sort((a, b) => {
    const comparison = a.name.localeCompare(b.name);
    return order === "asc" ? comparison : -comparison;
  });
};

const sortByPoints = (users, order) => {
  return [...users].sort((a, b) => {
    const pointsA = a.challenge?.earnedPoints || 0;
    const pointsB = b.challenge?.earnedPoints || 0;
    return order === "asc" ? pointsA - pointsB : pointsB - pointsA;
  });
};

const sortByPosition = (users, order) => {
  return [...users].sort((a, b) => {
    return order === "asc" ? a.index - b.index : b.index - a.index;
  });
};

const sortByPercent = (users, order) => {
  return [...users].sort((a, b) => {
    const percentA = a.challenge?.contentsCompleted || 0;
    const percentB = b.challenge?.contentsCompleted || 0;
    return order === "asc" ? percentA - percentB : percentB - percentA;
  });
};

const lookByName = (users, search) => {
  const searchTerm = search.toLowerCase();
  return users.filter((user) => user.name.toLowerCase().includes(searchTerm));
};

const getChallengeAdminDetails = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_CHALLENGE_ADMIN_DETAILS:
      return action.payload;
    case actionTypes.SORT_BY_NAME:
      return { ...state, users: sortByName(state.users, action.payload) };
    case actionTypes.SORT_BY_POINTS:
      return { ...state, users: sortByPoints(state.users, action.payload) };
    case actionTypes.SORT_BY_POSITION:
      return { ...state, users: sortByPosition(state.users, action.payload) };
    case actionTypes.SORT_BY_PERCENT:
      return { ...state, users: sortByPercent(state.users, action.payload) };
    case actionTypes.LOOK_BY_NAME:
      const [search, originalState] = action.payload;
      return search === ""
        ? originalState
        : { ...state, users: lookByName(state.users, search) };
    default:
      return state;
  }
};

//! Hasta aca

const getSpecificContent = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_SPECIFIC_CONTENT:
      return action.payload;
    case actionTypes.RESET_CONTENT_STATE:
      // console.log(
      //   "getSpecificContentReducer: RESET_CONTENT_STATE",
      //   action.payload
      // );
      return action.payload;
    case actionTypes.EDIT_CONTENT:
      // console.log("getSpecificContentReducer: EDIT_CONTENT", action.payload);
      return null;
    default:
      return state;
  }
};

const getQuestions = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_QUESTIONS:
      // console.log(action.payload);
      return action.payload;
    case actionTypes.GET_JSON:
      // console.log(action.payload);
      return action.payload;
    default:
      return state;
  }
};

const getUserPoints = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_POINTS:
      // console.log(action.payload);
      return action.payload;
    default:
      return state;
  }
};

const getCompanyPoints = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANY_POINTS:
      // console.log(action.payload);
      return action.payload;
    default:
      return state;
  }
};

const getAdmin2 = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_CHALLENGE_ADMIN_DETAILS:
      // console.log(action.payload);
      return action.payload;
    default:
      return state;
  }
};

const getExams = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.GET_EXAMS:
      return action.payload;
    default:
      return state;
  }
};

const getBadges = (state = [], action) => {
  switch (action.type) {
    case actionTypes.COMPLETE_CONTENT:
      return action.payload;
    case actionTypes.UPDATE_MEDAL:
      return action.payload;
    case actionTypes.CLEAN_BADGES:
      return [];
    default:
      return state;
  }
};
const getSocial = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_SOCIAL:
      return action.payload;
    case actionTypes.UPDATE_SOCIAL:
      return action.payload;
    case actionTypes.SOCIAL_REVIEW:
      return action.payload;
    case actionTypes.CLEAR_SOCIAL:
      return [];
    default:
      return state;
  }
};

const getCompanyUsers = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_USERS_BY_COMPANY:
      return action.payload;
    case actionTypes.GIVE_ADMIN:
      return action.payload;
    default:
      return state;
  }
};

const getCompanies = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANIES:
      return action.payload;
    default:
      return state;
  }
};

const allChallengesReducer = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_CHALLENGES:
      return action.payload;
    default:
      return state;
  }
};

const getCompanyUsersInfo = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_COMPANY_USERS_INFO:
      return action.payload;
    default:
      return state;
  }
};
// combinamos los reducers usando la función combineReducers
// el objeto que pasamos como argumento indica cómo queremos que se llamen los diferentes estados en el store de redux
// y qué reducer se encarga de actualizar cada uno de esos estados
const rootReducer = combineReducers({
  users: usersReducer, // el estado de los usuarios lo maneja el reducer usersReducer
  challenges: challengesReducer, // el estado de los retos lo maneja el reducer challengesReducer
  ownChallenges: ownChallengesReducer,
  specificUser: specificUserReducer,
  userPoints: getUserPoints,
  companyPoints: getCompanyPoints,
  specificChallenge: specificChallenge,
  ranking: rankingReducer,
  stages: getStages,
  specificStage: getSpecificStage,
  StageMsgs: createStage,
  company: getCompany,
  companyMsg: companyMsgReducer,
  challengeMsg: challengeMsgReducer,
  content: getSpecificContent,
  questions: getQuestions,
  challengeAdminDetails: getChallengeAdminDetails,
  challengeAdminDetailsBackUp: getAdmin2,
  userExams: getExams,
  badges: getBadges,
  social: getSocial,
  companyUsers: getCompanyUsers,
  companyUsersInfo: getCompanyUsersInfo,
  SACompanies: getCompanies,
  allChallenges: allChallengesReducer,
});

// exportamos el reducer combinado
export default rootReducer;
